import { TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/core/services/login.service';
import { ToastNotificationService } from 'src/app/core/services/toast-notification.service';

@Component({
  selector: 'app-change-forgot-password',
  templateUrl: './change-forgot-password.component.html',
  styleUrls: ['./change-forgot-password.component.scss']
})
export class ChangeForgotPasswordComponent implements OnInit {

  ChangeOTPPasswordForm:any;
  public submitted: boolean;
  constructor(private formBuilder: FormBuilder, private toastService:ToastNotificationService,private loginService: LoginService,private router: Router,  private titleCasePipe: TitleCasePipe) { }

  ngOnInit(): void {
    this.ChangeOTPPasswordForm = this.formBuilder.group({
			forgetpass: ["",[Validators.required,Validators.email,Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
     ]],
      otp:["",[Validators.required]],
      newPassword:["",[Validators.required]],
    });
  }
  get f(){
    return this.ChangeOTPPasswordForm.controls;
  }
  postforgotpassword(){
    this.submitted=true;
    if(this.ChangeOTPPasswordForm.invalid){
      return false;
    }
    else{
      let body={
        "email" : this.ChangeOTPPasswordForm.controls.forgetpass.value,
        "otp" : this.ChangeOTPPasswordForm.controls.otp.value,
        "newPassword" :this.ChangeOTPPasswordForm.controls.newPassword.value

      }
      this.loginService.changeForgetPassword(body).then((res)=>{
        this.toastService.toastMsg({
          title: "Success",
          content: "Password Changed Successfully!!!",
        });
        // this.toastService.openSnackBar("Password Changed Successfully");
        this.router.navigate(["/auth/login"]);
      }, 
      (err) => {
      
        if(err.error.expose){
          this.toastService.toastMsg({
            title: "Error",
            content: this.titleCasePipe.transform(err.error.error_message),
          });
          // this.toastService.openErrorSnackBar(this.titleCasePipe.transform(err.error.error_message));
        }
        else{
          this.toastService.toastMsg({
            title: "Error",
            content: "Something Went Wrong.",
          });
          // this.toastService.openErrorSnackBar("Something Went Wrong.");
        }
        
      })

  
    }
    

  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

}
